import { Link } from "react-router-dom";
import { FileText, ShieldCheck } from "lucide-react";

const DocLink = ({ doc, children }) => (
  <Link to={`/legal/clinician/${doc}`} target="_blank" rel="noopener noreferrer" className="font-semibold text-[#2A5298] underline underline-offset-2" data-testid={`legal-link-${doc}`}>{children}</Link>
);

function Box({ checked, onChange, testid, children, required }) {
  return (
    <label className={`flex items-start gap-2.5 rounded-xl border px-3 py-2.5 cursor-pointer transition-colors ${checked ? "border-teal-300 bg-teal-50/50" : "border-slate-200 bg-white hover:bg-slate-50"}`}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 shrink-0 accent-teal-700" data-testid={testid} aria-required={required} />
      <span className="text-[12px] leading-relaxed text-slate-700">{children}</span>
    </label>
  );
}

export function KeyTerms({ legal }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50/70" data-testid="legal-key-terms">
      <div className="flex items-center gap-1.5 px-3 pt-2.5 text-[12px] font-semibold text-slate-800"><FileText size={13} /> Key terms at a glance <span className="font-normal text-slate-400">· v{legal.version}</span></div>
      <div className="max-h-32 overflow-y-auto px-3 pb-2.5 pt-1 text-[11.5px] leading-relaxed text-slate-600 whitespace-pre-wrap">{legal.key_terms}</div>
    </div>
  );
}

export default function ClinicianTerms({ legal, value, onChange }) {
  if (!legal) return null;
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  const a1 = legal.a1.split("End User License Agreement and Terms of Use");
  const [beforePp, afterPp] = (a1[1] || "").split("Privacy Policy");
  return (
    <div className="space-y-2.5 mt-1 mb-1" data-testid="clinician-terms">
      <KeyTerms legal={legal} />
      <Box checked={value.b} onChange={set("b")} testid="legal-schedule-b" required>
        <span className="font-semibold text-slate-900">{legal.schedule_b_intro}</span>
        <ul className="mt-1.5 max-h-40 overflow-y-auto list-disc pl-4 space-y-1 text-[11.5px] text-slate-600" data-testid="legal-schedule-b-list">
          {legal.schedule_b.map((s) => <li key={s.slice(0, 40)}>{s}</li>)}
        </ul>
      </Box>
      <Box checked={value.a1} onChange={set("a1")} testid="legal-a1" required>
        {a1[0]}<DocLink doc="eula">End User License Agreement and Terms of Use</DocLink>{beforePp}<DocLink doc="privacy">Privacy Policy</DocLink>{afterPp}
      </Box>
      <Box checked={value.a2} onChange={set("a2")} testid="legal-a2">
        {legal.a2} <span className="text-slate-400">(optional)</span>
      </Box>
      <p className="flex items-center gap-1 text-[10.5px] text-slate-400"><ShieldCheck size={11} /> Service, safety and compliance messages are always sent. Displayed in English.</p>
    </div>
  );
}
